<template>
    <VeeForm as="div" class="filter-heading w-auto my-0 my-xl-2 flex-fill">
        <form>
            <Field v-slot="{ value }" name="orderBy" class="form-select cursor-pointer" as="select" v-model="this.sortValue">
                <option v-for="(option, key) in sortOptions" :key="key" :value="option.value" :selected="value && value.includes(option.label)">{{ option.label }}</option>
            </Field>
        </form>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field} from 'vee-validate';

    export default {
        props: [''],
        components: {
            VeeForm,
            Field
        },
        data() {
            return {
                sortValue: this.$parent.$parent.defaultTyreSort
            }
        },
        methods: {
        },
        watch: {
            sortValue(newValue) {
                //re-run selectFilter function to add sort option to url and return sorted tyres.
                this.$parent.$parent.selectFilter(this.$parent.$parent.homeDelivery, newValue);
            }
        },
        computed: {
            sortOptions: function() {
                return [
                    { value: 'popularity_desc', label: 'Popularity'},
                    { value: 'price_asc', label: 'Price low - high'},
                    { value: 'price_desc', label: 'Price high - low'},
                    { value: 'brand_asc', label: 'Brand name a - z'},
                    { value: 'brand_desc', label: 'Brand name z - a'},
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>